// Sesion del usuario (token + datos) en localStorage
const KEY = 'session';

export function getSession() {
    try {
        return JSON.parse(localStorage.getItem(KEY));
    } catch (e) {
        return null;
    }
}

export function setSession(session) {
    localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession() {
    localStorage.removeItem(KEY);
}

export function isSuperAdmin() {
    const session = getSession();
    return !!session && session.user && session.user.role === 'superadmin';
}
